import { lazy } from 'react';

/**
 * Shared Settings loader so `/settings` and `/dashboard/settings` use one chunk.
 *
 * Two separate `React.lazy(() => import(...))` entry points (App.js historically
 * lazy-loaded both `pages/Settings` and `pages/dashboard/DashboardSettingsPage`,
 * which re-imports Settings) let webpack emit a partial module on first SPA
 * navigation: React.lazy caches `default: undefined` and the route goes blank
 * until a full reload. Trade uses the same single-import() pattern.
 */
export const loadSettingsPage = () =>
  import(
    /* webpackChunkName: "settings-page" */
    '../pages/Settings'
  ).then((m) => {
    const Settings = m.default;
    if (typeof Settings !== 'function') {
      throw new Error('Settings page module did not export a component');
    }
    return { default: Settings };
  });

export const loadDashboardSettingsPage = () =>
  loadSettingsPage().then(() =>
    import(
      /* webpackChunkName: "settings-page" */
      '../pages/dashboard/DashboardSettingsPage'
    )
  );

export const SettingsPage = lazy(loadSettingsPage);
export const DashboardSettingsPage = lazy(loadDashboardSettingsPage);
